// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"rM-z","upvoteIcon":"sM-z","downvoteIcon":"tM-z","feedbackIcon":"uM-z"};